import { createSlice } from '@reduxjs/toolkit';
import api from '../actions/configApi'; // Assumindo que você tem um arquivo de API configurado

// Função para carregar o carrinho do localStorage
const loadCartFromLocalStorage = () => {
    try {
        const cart = localStorage.getItem('cart');
        return cart ? JSON.parse(cart) : [];
    } catch (error) {
        console.error("Erro ao carregar o carrinho do localStorage:", error);
        return [];
    }
};

// Função para salvar o carrinho no localStorage
const saveCartToLocalStorage = (cart) => {
    try {
        localStorage.setItem('cart', JSON.stringify(cart));
    } catch (error) {
        console.error("Erro ao salvar o carrinho no localStorage:", error);
    }
};

const calculateTotal = (products) => {
    return products.reduce((total, product) => total + product.price * product.quantity, 0);
};

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        products: JSON.parse(localStorage.getItem('cart')) || [],
        totalAmount: parseFloat(localStorage.getItem('totalAmount')) || 0,
        deliveryMethod: '', // 'retirada' ou 'entrega'
    },
    reducers: {
        addProductToCart: (state, action) => {
            const product = action.payload;
            const existingProduct = state.products.find((item) => item.id === product.id);

            if (!existingProduct) {
                state.products.push({ ...product, quantity: product.quantity || 1 });
            }
            state.totalAmount = calculateTotal(state.products);
            localStorage.setItem('cart', JSON.stringify(state.products));
            localStorage.setItem('totalAmount', state.totalAmount);
        },
        removeProductFromCart: (state, action) => {
            state.products = state.products.filter((product) => product.id !== action.payload);
            state.totalAmount = calculateTotal(state.products);
            localStorage.setItem('cart', JSON.stringify(state.products));
            localStorage.setItem('totalAmount', state.totalAmount);
        },
        clearCart: (state) => {
            state.products = [];
            saveCartToLocalStorage(state.products); // Salva no localStorage
        },
        updateProductQuantity: (state, action) => {
            const { productId, quantity } = action.payload;
            const product = state.products.find((item) => item.id === productId);

            if (product && quantity > 0) {
                product.quantity = quantity;
            } else {
                state.products = state.products.filter((item) => item.id !== productId);
            }
            state.totalAmount = calculateTotal(state.products);
            localStorage.setItem('cart', JSON.stringify(state.products));
            localStorage.setItem('totalAmount', state.totalAmount);
        },
        setDeliveryMethod: (state, action) => {
            state.deliveryMethod = action.payload;
            localStorage.setItem('deliveryMethod', state.deliveryMethod);
        },
        finalizePurchase: (state) => {
            // Armazena as informações de finalização
            const purchaseSummary = {
                products: state.products,
                totalAmount: state.totalAmount,
                deliveryMethod: state.deliveryMethod,
            };
            localStorage.setItem('purchaseSummary', JSON.stringify(purchaseSummary));
        },
    },
});

export const { 
    addProductToCart,
    removeProductFromCart,
    updateProductQuantity,
    setDeliveryMethod,
    finalizePurchase,
} = cartSlice.actions;

export default cartSlice.reducer;
